module.exports = "<div class=\"switcher\">\n  <p class=\"label-switcher\">{{ title }}</p>\n  <div class=\"container-switcher\">\n      <input type=\"checkbox\" [id]=\"element\" [name]=\"element\" [(ngModel)]=\"switcher\" [checked]=\"switcher\" (change)=\"change()\" [disabled]=\"disabled\" data-switch=\"primary\">\n      <label [for]=\"element\" data-in-label=\"Sí\" data-off-label=\"No\"></label>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/switcher/switcher.component.html
// module id = ./src/app/components/tools/switcher/switcher.component.html
// module chunks = main